import { atom } from 'jotai';

const filterTrayOpenAtom = atom(false, (_get, set, newValue) => {
  set(filterTrayOpenAtom, newValue);
});

export { filterTrayOpenAtom };
